import React, {useEffect, useState} from "react";
import I18n from 'i18n.js.erb'

const ProductSearchBar = ({  }) => {

  const [ value, setValue ] = useState('')
  const [ focus, setFocus ] = useState(false)

  const handleNavigation = (e) => {
    if (e.key === 'Enter' && focus && value && value !== '') {
      let found_not_zero_value = false;
      let value_without_padding = '';
      for (let i=0; i<value.length; i++) {
        if (value[i] !== '0')
          found_not_zero_value = true
        if (found_not_zero_value)
          value_without_padding += value[i]
      }
      window.location = `/grading_certificate/${value_without_padding}`;
    }
  }

  return (
    <div className={`d-flex justify-content-center align-items-center br-20px bg-white ${focus ? 'border-aiG-blue-imp' : 'border-aiG-black-imp'}`}>
      <i className="fas fa-search ml-3 mr-1" />
      <input
        id="global_search_bar"
        type="number"
        value={value}
        className={'form-control w-100 border-none br-20px'}
        onChange={ (e) => setValue(e.target.value) }
        placeholder={I18n.t('js.home_page.searchCardBySerialNumber')}
        onFocus={ () => setFocus(true) }
        onBlur={ () => setFocus(false) }
        onKeyDown={ (e) => handleNavigation(e) }
      />
    </div>
  );
};

export default ProductSearchBar;
